import { type InferOutput, array, boolean, nullish, number, object, partial, record, string } from "valibot"

// currentHolding
export const currentHoldingSchema = object({
  id: nullish(string()),
  productCategory: nullish(string()),
  accumulationAmount: nullish(number()),
  monthlyDepositAmount: nullish(number()),
  accumulationManagementFee: nullish(number()),
  depositManagementFee: nullish(number()),
  fundId: nullish(string()),
  fundShortText: nullish(string()),
  companyLogo: nullish(string()),
  reportedSalary: nullish(number()),
  compensationProvisionPercentage: nullish(number()),
  employerProvisionPercentage: nullish(number()),
  employeeProvisionPercentage: nullish(number()),
  isSelected: nullish(boolean()),
})

export type CurrentHolding = InferOutput<typeof currentHoldingSchema>

// targetHolding
export const targetHoldingSchema = object({
  id: nullish(string()),
  productCategory: nullish(string()),
  accumulationAmount: nullish(number()),
  monthlyDepositAmount: nullish(number()),
  accumulationManagementFee: nullish(number()),
  depositManagementFee: nullish(number()),
  fundId: nullish(string()),
  fundShortText: nullish(string()),
  companyLogo: nullish(string()),
  reportedSalary: nullish(number()),
})

export type TargetHolding = InferOutput<typeof targetHoldingSchema>

export const TransactionSchema = object({
  id: nullish(string()),
  title: nullish(string()),
  description: nullish(string()),
  isDynamic: nullish(boolean()),
  action: nullish(string()),
  simulation: nullish(record(string(), string())),
  currentHoldings: array(partial(currentHoldingSchema)),
  targetHoldings: array(partial(targetHoldingSchema)),
})
export type Transaction = InferOutput<typeof TransactionSchema>

export const PensionRecommendationSchema = object({
  id: string(),
  title: nullish(string()),
  description: nullish(string()),
  reason: nullish(string()),
  category: string(),
  isSelected: nullish(boolean()),
  transactions: array(TransactionSchema),
})
export type PensionRecommendation = InferOutput<typeof PensionRecommendationSchema>

export const ReCalculateRecommendationSchema = object({
  transactions: array(
    object({
      transactionId: string(),
      holdings: array(
        object({
          holdingId: string(),
          isSelected: boolean(),
        })
      ),
    })
  ),
})

export type ReCalculateRecommendation = InferOutput<typeof ReCalculateRecommendationSchema>
